import { render, staticRenderFns } from "./Lottie.vue?vue&type=template&id=615a43c2&scoped=true&"
import script from "./Lottie.vue?vue&type=script&lang=js&"
export * from "./Lottie.vue?vue&type=script&lang=js&"
import style0 from "./Lottie.vue?vue&type=style&index=0&id=615a43c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615a43c2",
  null
  
)

export default component.exports